import type {
	VideoJsPlayerOptions,
	VideoJsPlayerPluginOptions,
} from 'video.js';

const pluginsConfig: VideoJsPlayerPluginOptions = {
	seekButtons: {
		back: 10,
	},
	hotkeys: {
		alwaysCaptureHotkeys: true,
		enableHoverScroll: true,
		enableVolumeScroll: false,
	},
};

export interface PatchedVideoJsPlayerOptions
	extends Omit<VideoJsPlayerOptions, 'textTrackSettings'> {
	textTrackSettings?: VideoJsPlayerOptions['textTrackSettings'] | false; // Allow false, as described in the docs: https://videojs.com/guides/text-tracks/#text-track-settings
}

/*
 * Basic config for Video JS initialisation
 */
export const videoPlayerConfig: PatchedVideoJsPlayerOptions = {
	fluid: true,
	plugins: pluginsConfig,
	textTrackSettings: false, // Disables unwanted "Caption Settings" button from being shown
	controlBar: {
		volumePanel: { inline: false },
		children: [
			{
				name: 'playToggle',
			},
			{
				name: 'currentTimeDisplay',
			},
			{
				name: 'progressControl',
			},
			{
				name: 'volumePanel',
			},
			{
				name: 'subsCapsButton',
			},
			{
				name: 'descriptionsButton',
			},
			{
				name: 'fullscreenToggle',
			},
		],
	},
};
